import type { Section } from "../types";
import { g2Reader } from "./products/g2Reader";
import { g2ReaderPro } from "./products/g2ReaderPro";
import { g3Intercom } from "./products/g3Intercom";
import { g3Reader } from "./products/g3Reader";
import { g3ReaderFlex } from "./products/g3ReaderFlex";
import { g3ReaderPro } from "./products/g3ReaderPro";
import { g6Entry } from "./products/g6Entry";
import { g6ProEntry } from "./products/g6ProEntry";
import { intercom } from "./products/intercom";
import { readerAccessUltra } from "./products/readerAccessUltra";
import { retrofitReader } from "./products/retrofitReader";
import {
  cameraReader,
  dimensions,
  directory,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "./properties";

export const Readers: Section = {
  properties: [
    dimensions,
    cameraReader,
    twoWayIntercom,
    directory,
    touchPassSupport,
    pinAccess,
    nfcCard,
    mobileAppAccess,
    outdoorReady,
    readerPowerMethod,
  ],
  products: [
    g6ProEntry,
    g6Entry,
    g3ReaderPro,
    g3ReaderFlex,
    g3Reader,
    g3Intercom,
    intercom,
    retrofitReader,
    readerAccessUltra,
    g2ReaderPro,
    g2Reader,
  ],
  columnWidth: 260,
  propertyColumnWidth: 210,
  showBadges: true,
};
